import React, { memo, useEffect, useState } from "react";
import clsx from "clsx";

import {
  Button,
  Drawer,
  Grid,
  Hidden,
  IconButton,
  Paper,
  Slide,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import theme from "../theme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTranslation } from "react-i18next";

import PhoneRunner from "./icons/PhoneRunner";
import AskIcon from "./icons/askIcon.svg";
import {
  Close,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@material-ui/icons";
import WhatsappIcon from "./icons/WhatsappRunner";
import MarkabtePhone from "./MarkabtePhone";
import { removePhoneZero } from "../helpers/functions";
import { connect } from "react-redux";
import { toggleNotification } from "../store/actions/notification";
import { requestCallBack } from "../store/actions/car";

const useStyles = makeStyles((theme) => ({
  mainDiv: {
    boxSizing: "border-box",
    border: "0.929185px solid #ADB5BA",
    borderRadius: "3px", // removed to not messup the outline's border
    padding: "16px 18px 32px 18px",
    display: "flex",
    flexDirection: "column",
    margin: "23px 0",
    minWidth: "100%",
    [theme.breakpoints.up("md")]: {
      border: "none",
      margin: 0,
    },
  },
  button: {
    color: "white",
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 600,
    paddingBlock: "12px",
  },
  greenButton: {
    backgroundColor: "#3CB656",
    "&:hover": {
      backgroundColor: "#2C6E4D",
    },
  },
  //   ////////////////////////////////
  loggedContentDiv: {
    paddingBottom: "16px",
    [theme.breakpoints.up("md")]: {
      borderBottom: "1px solid #B1B1B1",
      marginBottom: "20px",
    },
  },
  loggedOutContentDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  loggedIconTitleDiv: {
    display: "flex",
    width: "100%",
  },
  titleDiv: {
    display: "flex",
    paddingBottom: "20px",
    borderBottom: "1px solid #B1B1B1",
    width: "100%",
    marginBottom: "8px",
    justifyContent: "center",
  },
  iconMarginRight: {
    marginRight: "8px",
  },
  loggedTitle: {
    marginBottom: "4px",
    fontSize: "18px",
    fontWeight: 600,
    color: "#07303E",
    whiteSpace: "nowrap",
  },
  loggedContent: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#6B8495",
  },
  ////////////////////////////////////////
  bookAppointmentPaper: {
    top: 0,
    left: 0,
    boxShadow: "0px 3.28852px 5.26164px rgba(10, 47, 60, 0.2);",
    backgroundColor: "#F9FAFD",
    width: "100%",
    zIndex: 1,
  },
  contentMainDiv: {
    padding: "16px",
    paddingBottom: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "calc(100% - 40px)",
  },
  headerDiv: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #C4C4C4",
    paddingBottom: "8px",
    marginBottom: "16px",
    alignItems: "start",
    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-start",
    },
  },
  headerTitleSubtitle: {
    [theme.breakpoints.up("md")]: {
      marginInline: "auto",
    },
  },
  headerTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#07303E",
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
    },
  },
  headerSubtitle: {
    fontSize: "15px",
    color: "#07303E",
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
    },
  },
  closeIconButton: {
    transform: "translate(12px,-12px)",
  },
  ////////////////////////////////////////////
  actionBarRelative: {
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      transformOrigin: "bottom left",
      zIndex: 10,
      width: "100%",
      left: 0,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "50px",
      height: "100%",
      position: "relative",
    },
  },
  actionBarPaper: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      boxShadow: "0px -3.28852px 5.26164px rgba(10, 47, 60, 0.2);",
      borderRadius: 0,
      padding: "10px 24px",
    },
  },
  /////////////////////////////////////////
}));

const MethodSelect = memo((props) => {
  const { t } = useTranslation();

  const classes = useStyles();

  const { handleClose, setDrawerSliderState, carCard, car } = props;

  const handleCallback = (e) => {
    e.stopPropagation();
    setDrawerSliderState({ open: true, tab: 1 });
  };

  const handleWhatsapp = (e) => {
    e.stopPropagation();
    window.open(
      `https://wa.me/+962795087430/?text= ${t("I have an inquiry regarding")} ${
        carCard?.make
      }  ${carCard?.model} ${carCard?.year} ${t("with listing id")} ${car?.id}`
    );
    handleClose();
  };

  return (
    <>
      <Button
        className={clsx({ [classes.button]: 1, [classes.greenButton]: 1 })}
        style={{ marginBottom: "16px" }}
        fullWidth
        variant="contained"
        startIcon={<PhoneRunner size={16} fill={"white"} />}
        onClick={handleCallback}
      >
        {t("Call me")}
      </Button>
      <Button
        className={clsx({ [classes.button]: 1 })}
        fullWidth
        color="primary"
        variant="contained"
        startIcon={<WhatsappIcon size={16} fill={"white"} />}
        onClick={handleWhatsapp}
      >
        {t("Send Whatsapp Text")}
      </Button>
    </>
  );
});

const CallMe = memo((props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { handleClose, car, requestCallBack, toggleNotification } = props;

  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handleCallback = (e) => {
    e.stopPropagation();
    if (phone.length == 13) {
      requestCallBack({
        carId: car.id,
        phoneNumber: phone,
        callback: (response) => {
          if (response.success) {
            toggleNotification({
              open: true,
              message: t("Markabte agent will call you shortly."),
              variant: "success",
            });
          } else {
            toggleNotification({
              open: true,
              message: t("Oops! an error has occured! please try again."),
              variant: "error",
            });
          }
        },
      });
      handleClose();
    } else {
      setError("Please check you'r phone number");
    }
  };

  useEffect(() => {
    if (phone?.[4] == "0") {
      let phoneNumber = removePhoneZero(phone);
      setPhone(phoneNumber);
    }
    if (phone?.length < 4 || phone == undefined) {
      setPhone("+962");
    }
  }, [phone]);

  return (
    <>
      <MarkabtePhone
        errors={t(error)}
        value={phone}
        onChange={(e) => {
          setPhone(e);
        }}
      />
      <Button
        className={clsx({ [classes.button]: 1, [classes.greenButton]: 1 })}
        style={{ marginBottom: "16px" }}
        fullWidth
        variant="contained"
        startIcon={<PhoneRunner size={16} fill={"white"} />}
        onClick={handleCallback}
      >
        {t("Call me")}
      </Button>
    </>
  );
});

const DrawerSliderContent = memo(
  ({
    handleClose,
    car,
    carCard,
    setDrawerSliderState,
    tab,
    requestCallBack,
    toggleNotification,
  }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const methodTab = {
      title: "Contact Technician",
      subtitle: "Choose method of contact below",
      content: (
        <MethodSelect
          handleClose={handleClose}
          setDrawerSliderState={setDrawerSliderState}
          carCard={carCard}
          car={car}
        />
      ),
    };

    const callTab = {
      title: "Call me",
      subtitle: "Enter your phone number and you will be contacted shortly",
      content: (
        <CallMe
          handleClose={handleClose}
          car={car}
          requestCallBack={requestCallBack}
          toggleNotification={toggleNotification}
        />
      ),
    };

    const tabs = [methodTab, callTab];

    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    useEffect(() => {
      setSelectedTab(tabs[tab]);
    }, [tab]);

    const handleBack = () => {
      setDrawerSliderState((prev) => {
        if (!prev.tab) {
          return { open: false, tab: 0 };
        }
        return { open: true, tab: prev.tab - 1 };
      });
    };

    return (
      <div className={classes.contentMainDiv}>
        <div className={classes.headerDiv}>
          <Hidden smDown>
            {theme.direction === "ltr" ? (
              <KeyboardArrowLeft
                onClick={handleBack}
                style={{
                  fill: "#07303E",
                  fontSize: "33px",
                  cursor: "pointer",
                  transform: "translate(-8px,-4px)",
                }}
              />
            ) : (
              <KeyboardArrowRight
                onClick={handleBack}
                style={{
                  fill: "#07303E",
                  fontSize: "33px",
                  cursor: "pointer",
                  transform: "translate(8px,-4px)",
                }}
              />
            )}
          </Hidden>
          <div className={classes.headerTitleSubtitle}>
            <Typography className={classes.headerTitle}>
              {t(selectedTab?.title)}
            </Typography>
            <Typography className={classes.headerSubtitle}>
              {t(selectedTab?.subtitle)}
            </Typography>
          </div>
          <Hidden mdUp>
            <IconButton
              onClick={!tab ? handleClose : handleBack}
              className={classes.closeIconButton}
            >
              {!tab ? (
                <Close style={{ color: "#07303E" }} />
              ) : (
                <>
                  {theme.direction === "ltr" ? (
                    <KeyboardArrowRight
                      style={{
                        fill: "#07303E",
                        fontSize: "25px",
                      }}
                    />
                  ) : (
                    <KeyboardArrowLeft
                      style={{
                        fill: "#07303E",
                        fontSize: "25px",
                      }}
                    />
                  )}
                </>
              )}
            </IconButton>
          </Hidden>
        </div>
        <div style={{ marginBlock: "auto" }}>{selectedTab?.content}</div>
      </div>
    );
  }
);

const DrawerSlider = memo((props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    drawerSliderState,
    setDrawerSliderState,
    handleClose,
    car,
    carCard,
    requestCallBack,
    toggleNotification,
  } = props;
  const { open } = drawerSliderState;

  return (
    <>
      <Hidden smDown>
        <Slide
          direction={theme.direction === "ltr" ? "left" : "right"}
          in={open}
          timeout={200}
          mountOnEnter
          unmountOnExit
          style={!open ? { display: "none" } : {}}
        >
          <Paper square className={classes.bookAppointmentPaper}>
            <DrawerSliderContent
              handleClose={handleClose}
              car={car}
              carCard={carCard}
              setDrawerSliderState={setDrawerSliderState}
              tab={drawerSliderState.tab}
              requestCallBack={requestCallBack}
              toggleNotification={toggleNotification}
            />
          </Paper>
        </Slide>
      </Hidden>
      <Hidden mdUp>
        <Drawer open={open} anchor="bottom" onClose={handleClose}>
          <DrawerSliderContent
            handleClose={handleClose}
            car={car}
            carCard={carCard}
            setDrawerSliderState={setDrawerSliderState}
            tab={drawerSliderState.tab}
            requestCallBack={requestCallBack}
            toggleNotification={toggleNotification}
          />
        </Drawer>
      </Hidden>
    </>
  );
});

const DescriptionComponent = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div
      className={clsx({
        [classes.loggedContentDiv]: 1,
        [classes.loggedOutContentDiv]: true,
      })}
    >
      <div className={classes.loggedIconTitleDiv}>
        <div className={classes.titleDiv}>
          <img
            src={AskIcon}
            width="25px"
            className={classes.iconMarginRight}
            loading="lazy"
          />
          <Typography className={classes.loggedTitle}>
            {t("Questions and Inquiries")}
          </Typography>
        </div>
      </div>
      <Typography className={classes.loggedContent}>
        {t(
          "Any question or inquiry? Contact our technical support specialist."
        )}
      </Typography>
    </div>
  );
};

const ButtonSellector = memo((props) => {
  const { t } = useTranslation();
  const { handleOpen } = props;

  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={handleOpen}
          className={clsx({
            [classes.greenButton]: 1,
            [classes.button]: 1,
          })}
          children={t("Connect")}
          startIcon={<PhoneRunner size={16} fill="white" />}
          fullWidth
        />
      </Grid>
    </Grid>
  );
});

const MobBottomAction = memo((props) => {
  const classes = useStyles();

  const { children, isVisible } = props;
  return (
    <Hidden mdUp>
      <Slide
        direction="up"
        in={!isVisible}
        timeout={100}
        mountOnEnter
        unmountOnExit
      >
        <div className={classes.actionBarRelative}>
          <Paper className={classes.actionBarPaper}>{children}</Paper>
        </div>
      </Slide>
    </Hidden>
  );
});

const BuyerReportActionBar = memo((props) => {
  const { car, isVisible, carCard, requestCallBack, toggleNotification } =
    props;
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [drawerSliderState, setDrawerSliderState] = useState({
    open: false,
    tab: 0,
  });
  const handleClose = () => {
    setDrawerSliderState({ open: false, tab: 0 });
  };

  return (
    <div style={{ display: "flex" }}>
      <Slide
        direction={theme.direction === "ltr" ? "left" : "right"}
        in={!drawerSliderState.open || smDown}
        timeout={200}
        mountOnEnter
        unmountOnExit
        className={classes.mainDiv}
        style={drawerSliderState.open && !smDown ? { display: "none" } : {}}
      >
        <div>
          <DescriptionComponent />
          <ButtonSellector
            handleOpen={() => {
              setDrawerSliderState({ open: true, tab: 0 });
            }}
          />
        </div>
      </Slide>
      <MobBottomAction isVisible={isVisible}>
        <ButtonSellector
          handleOpen={() => {
            setDrawerSliderState({ open: true, tab: 0 });
          }}
        />
      </MobBottomAction>
      <DrawerSlider
        drawerSliderState={drawerSliderState}
        setDrawerSliderState={setDrawerSliderState}
        handleClose={handleClose}
        carCard={carCard}
        car={car}
        requestCallBack={requestCallBack}
        toggleNotification={toggleNotification}
      />
    </div>
  );
});

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  toggleNotification(payload) {
    dispatch(toggleNotification(payload));
  },
  requestCallBack(payload) {
    dispatch(requestCallBack(payload));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuyerReportActionBar);
